import { useTranslation } from '@wojtekmaj/react-t';

import { VENDOR_BUSINESS_NAME } from '../constants';

import { MODE, PROD } from '../env';

const shortMode = MODE === 'development' ? 'dev' : MODE;

const title = PROD ? VENDOR_BUSINESS_NAME : `${VENDOR_BUSINESS_NAME} ${shortMode.toUpperCase()}`;

type TitleProps = {
  children?: string;
};

export default function Title({ children }: TitleProps) {
  const translatedChildren = useTranslation(children);

  return <title>{translatedChildren ? `${translatedChildren} • ${title}` : title}</title>;
}
